import { StockStatus } from '@constants/vendorVariantConstants';
import { IShopGroup } from '@components/shared/shop/model/ShopGroup';
import { IVendorGroup } from '@components/shared/shop/model/VendorGroup';
import { IMerchGroup } from '@models/MerchGroup/i-merch-group';

export const SHOP_PAGE_SIZE = 48;

export interface ShopProduct {
  id: string;
  sku: string;
  title: string;
  image: {
    url: string;
  };
  price: number;
  retailPrice: {
    price: string;
  };
  vendor: {
    name: string;
  };
  availability: StockStatus;
}

export interface ISearchHit {
  score: number;
  vendorVariant: ShopProduct;
}

export interface IFacet {
  name: string;
  values: IFacetValue[];
}

export interface ISearchResults {
  total: number;
  page: number;
  pageSize: number;
  hits: ISearchHit[];
  facets: Record<string, IFacet>;
}

export interface ISearchCriteria {
  facets?: string[];
  merchGroupIds?: number[];
  attributeFamilies?: number[] | number;
  onlyShopAssortment?: boolean;
  pageSize: number;
  page: number;
  priceMin?: number;
  priceMax?: number;
  query?: string;
  sort?: string;
  taxonomyIds?: number[];
  vendorIds?: number[];
}

export interface ISearchFilters {
  shopGroups?: IShopGroup[];

  selectedMerchGroup?: IMerchGroup;
  selectedShopGroupChain?: IShopGroup[];
  selectedVendorGroupChain?: IVendorGroup[];
}

export interface IFacetValue {
  id: string;
  value: string;
  count: number;
}

export function parsePriceFacetValue(value: IFacetValue) {
  const [lower, upper] = value.id.split('-');
  return [lower === '*' ? null : lower, upper === '*' ? null : upper];
}
